import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Box,
  CircularProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Link
} from "@material-ui/core";
import getAPI from "@API/index";
import AdminTable from "../AdminTable";

const useStyles = makeStyles((theme) => ({
  customerLink: {
    color: "#5195E6",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  placeholder: {
    textAlign: "center",
    color: "#54606F",
    padding: theme.spacing(4),
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

// Функция загрузки активных подписок
const loadActiveSubscriptions = async () => {
  try {
    const result = await getAPI().request({
      url: "/api/Customer",
      params: {
        subscriptionInfo: true
      }
    });
    // Фильтруем только активные подписки
    const activeSubscriptions = result.filter(customer => customer.isActiveSubscription === true);
    
    // Сортируем по дате окончания (ближайшие к окончанию сверху)
    return activeSubscriptions.sort((a, b) => {
      const dateA = new Date(a.subscriptionUntil);
      const dateB = new Date(b.subscriptionUntil);
      return dateA - dateB;
    });
  } catch (error) {
    console.error("Error loading active subscriptions:", error);
    return [];
  }
};

const ActiveSubscriptionsTab = () => {
  const classes = useStyles();
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSubscriptions();
  }, []);

  const loadSubscriptions = async () => {
    try {
      setLoading(true);
      const subscriptions = await loadActiveSubscriptions();
      setActiveSubscriptions(subscriptions);
    } catch (error) {
      console.error("Error loading subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Форматирование даты
  const formatDate = (dateString) => {
    if (!dateString || dateString === "0001-01-01T00:00:00") return "Не указано";
    return new Date(dateString).toLocaleDateString('ru-RU');
  };


  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Активные подписки
      </Typography>
      
      {activeSubscriptions.length > 0 ? (
        <AdminTable>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>Кастомер</TableCell>
                <TableCell className={classes.tableCell}>Дата начала</TableCell>
                <TableCell className={classes.tableCell}>Дата окончания</TableCell>
                <TableCell className={classes.tableCell} align="right">Остаток запросов</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {activeSubscriptions.map((customer) => (
                <TableRow key={customer.id}>
                  <TableCell scope="row" className={classes.tableCell}>
                    <Link
                      href={`/customer/details/${customer.id}`}
                      className={classes.customerLink}
                    >
                      {customer.name}
                    </Link>
                  </TableCell>
                  <TableCell className={classes.tableCell}>{formatDate(customer.subscriptionStart)}</TableCell>
                  <TableCell className={classes.tableCell}>{formatDate(customer.subscriptionUntil)}</TableCell>
                  <TableCell className={classes.tableCell} align="right">{customer.requestsLeft || 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
        </AdminTable>
      ) : (
        <Typography className={classes.placeholder}>
          Нет активных подписок
        </Typography>
      )}
    </Box>
  );
};

export default ActiveSubscriptionsTab;